let isOpen = false;
let $dropdown;

function init() {

	$dropdown = $('.login-slip__dropdown');

	if (!$dropdown.length) {
		return;
	}

	const $dropdownTrigger = $('.login-slip__dropdown-trigger');

	$('body').on('click', (event) => {

		const clickedInLoginDropdown = $dropdown[0].contains(event.target);
		const clickedInLoginDropdownTrigger = $dropdownTrigger[0].contains(event.target);

		if (!clickedInLoginDropdown && !clickedInLoginDropdownTrigger && isOpen) {
			dropdownClose();
		}

	});

	$dropdownTrigger.on('click', (event) => {
		if (isOpen) {
			dropdownClose();
		} else {
			dropdownShow();
		}
	});

}

function dropdownShow() {
	isOpen = true;
	$dropdown.addClass('is--open');
}

function dropdownClose() {
	isOpen = false;
	$dropdown.removeClass('is--open');
}

export default {
	init
};
